import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 1.66667C9.33696 1.66667 8.70107 1.93006 8.23223 2.3989C7.76339 2.86774 7.5 3.50363 7.5 4.16667V9.16667C7.5 9.82971 7.76339 10.4656 8.23223 10.9344C8.70107 11.4033 9.33696 11.6667 10 11.6667C10.663 11.6667 11.2989 11.4033 11.7678 10.9344C12.2366 10.4656 12.5 9.82971 12.5 9.16667V4.16667C12.5 3.50363 12.2366 2.86774 11.7678 2.3989C11.2989 1.93006 10.663 1.66667 10 1.66667Z",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8333 8.33333V9.16667C15.8333 10.7138 15.2188 12.1975 14.1248 13.2915C13.0308 14.3854 11.5471 15 10 15C8.4529 15 6.96917 14.3854 5.87521 13.2915C4.78125 12.1975 4.16667 10.7138 4.16667 9.16667V8.33333",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15V18.3333",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66667 18.3333H13.3333",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMic;
